export default __webpack_public_path__ + "static/janc-4853aa7cc011c62ed68220e69b1c9a28.jpg";